import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView'
import PaymeView from '@/views/RedirectView'
import YunoRedirectView from '@/views/YunoRedirect'
import YunoAPMRedirect from '@/views/YunoAPMRedirect'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:idSessionHash',
    name: 'home',
    props: true,
    component: HomeView
  },
  {
    path: '/redirect/payme',
    name: 'redirectPayme',
    component: PaymeView
  },
  {
    path: '/yuno/:url',
    name: 'redirectYuno',
    props: true,
    component: YunoRedirectView
  },
  {
    path: '/redirect/yunoapm/:paymentMethodType/:idSessionHash',
    name: 'yunoApm',
    component: YunoAPMRedirect
  }
]

const router = new VueRouter({
  routes
})

export default router
